import { Route, Switch } from 'react-router-dom';
import React from 'react';
import Login from '../../auth/login/go';
import LoginCallback from '../../auth/login/cb';
import SetInitialPassword from '../../auth/password';
import PrivateRoute from '../PrivateRoute';
import Home from '../../pages/Home';

// Note: don't add new pages here, this is just for authorisation and home page. Use the nested routes
const AppRoutes = () => (
	<Switch>
		<Route path="/auth/login/go" component={Login} />
		<Route path="/auth/login/cb" component={LoginCallback} />
		<Route path="/setpassword/:token" component={SetInitialPassword} />
		<PrivateRoute path="/" component={Home} />
	</Switch>
);

export default AppRoutes;
